import { Component, EventEmitter, Output } from '@angular/core';
import {
  AppearanceAnimation,
  ButtonLayoutDisplay,
  ButtonMaker,
  DialogInitializer,
  DialogLayoutDisplay,
  DisappearanceAnimation,
} from '@costlydeveloper/ngx-awesome-popup';
import { faTicket, faChevronDown, faCalendarDay, faBookmark } from '@fortawesome/pro-light-svg-icons';
import { CartService } from 'src/app/services/cart.service';
import { DialogSelectPaymentComponent } from '../dialog-select-payment/dialog-select-payment.component';
import { DialogPayComponent } from '../dialog-pay/dialog-pay.component';
import { faCartXmark, faTag, faPercent } from '@fortawesome/pro-regular-svg-icons';
import { DialogSaveReservationComponent } from '../dialog-save-reservation/dialog-save-reservation.component';
import { Router } from '@angular/router';
import { DialogCleanCartComponent } from '../dialog-clean-cart/dialog-clean-cart.component';
import { TicketsEventService } from 'src/app/services/tickets-event.service';
import { DialogErrorBondsComponent } from '../dialog-error-bonds/dialog-error-bonds.component';
import { Subscription } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { MatDialog } from '@angular/material/dialog';
import { DialogPromoCodeComponent } from '../dialog-promo-code/dialog-promo-code.component';

@Component({
  selector: 'app-products-resume',
  templateUrl: './products-resume.component.html',
  styleUrls: ['./products-resume.component.scss'],
})
export class ProductsResumeComponent {
  @Output() ticketRemoved = new EventEmitter<any>();
  faTicket = faTicket;
  faCalendar = faCalendarDay;
  faChevron = faChevronDown;
  faCartXMark = faCartXmark;
  faTag = faTag;
  faPercent = faPercent;
  faBookmark = faBookmark;
  seatsPayment!: any;
  cartUser: any = { cart_lines: [] };
  urlImages = AppSettings.API_EVENTS_ASSETS;

  promoRemoving: boolean = false;
  discountExpanded: boolean = false;

  get promoCodeDiscounts(): any[] {
    const d = this.cartUser?.applied_discounts;
    if (Array.isArray(d)) return d.filter((disc: any) => disc.type === 'promocode');
    return [];
  }

  get hasPromoCode(): boolean {
    return this.promoCodeDiscounts.length > 0;
  }

  get appliedDiscounts(): any[] {
    const d = this.cartUser?.applied_discounts;
    if (Array.isArray(d)) return d.filter((disc: any) => disc.type !== 'promocode');
    return [];
  }

  private cartSubscription: Subscription;
  private _groupState = new Map<string, boolean>();

  groupedCartLines: { event: any; session: any; groupKey: string; lines: any[]; total: number; quantityTotal: number; expanded: boolean }[] = [];

  get totalCartQuantity(): number {
    return (this.cartUser?.cart_lines || []).reduce((acc: number, l: any) => acc + (l.quantity || 1), 0);
  }

  private buildGroupedCartLines(): void {
    const lines: any[] = this.cartUser?.cart_lines || [];
    const map = new Map<string, { event: any; session: any; groupKey: string; lines: any[]; total: number; quantityTotal: number; expanded: boolean }>();
    for (const line of lines) {
      const eid = line.event?.id;
      const sid = line.session?.id;
      const key = `${eid}_${sid}`;
      if (!map.has(key)) {
        const existing = this._groupState.get(key);
        map.set(key, { event: line.event, session: line.session, groupKey: key, lines: [], total: 0, quantityTotal: 0, expanded: existing !== undefined ? existing : true });
      }
      const group = map.get(key)!;
      group.lines.push(line);
      group.quantityTotal += (line.quantity || 1);
      group.total += +(line.price_with_discount ?? (+line.price - +line.fee));
    }
    this.groupedCartLines = Array.from(map.values());
  }

  toggleGroup(groupKey: string) {
    const current = this._groupState.has(groupKey) ? this._groupState.get(groupKey)! : true;
    this._groupState.set(groupKey, !current);
    // Actualizar el estado expanded en el array ya construido sin reconstruir grupos
    const group = this.groupedCartLines.find(g => g.groupKey === groupKey);
    if (group) group.expanded = !current;
  }

  constructor(public cartService: CartService, private router: Router, private ticketsEventService: TicketsEventService, private dialog: MatDialog) {
    this.cartSubscription = this.cartService.cartStateObs$.subscribe({
      next: (cartState) => {
        this.cartUser = cartState || { cart_lines: [] };
        this.buildGroupedCartLines();
      }
    });
  }

  trackByGroup(_index: number, group: any): string {
    return group.groupKey;
  }

  trackByLine(_index: number, line: any): number {
    return line.id;
  }

  manejarEvento(seat: any) {
    this.emmitTicketRemoved(seat);
  }

  emmitTicketRemoved(seat: any) {
    this.ticketRemoved.emit(seat);
  }

  openPromoDialog() {
    const ref = this.dialog.open(DialogPromoCodeComponent, {
      width: '420px',
      disableClose: false,
    });
    ref.afterClosed().subscribe((result) => {
      if (result?.applied) {
        this.cartService.getCart().subscribe();
      }
    });
  }

  saveAsReservation() {
    const cartId = this.cartService.getCartId();
    if (!cartId) return;
    const ref = this.dialog.open(DialogSaveReservationComponent, {
      width: '460px',
      disableClose: false,
      data: { cartId },
    });
    ref.afterClosed().subscribe((result) => {
      if (result?.saved) {
        this.cartService.getCart().subscribe();
      }
    });
  }

  removePromo() {
    const cartId = this.cartService.getCartId();
    if (!cartId) return;
    this.promoRemoving = true;
    this.cartService.removePromoCode(cartId).subscribe({
      next: () => {
        this.promoRemoving = false;
        this.cartService.getCart().subscribe();
      },
      error: () => { this.promoRemoving = false; }
    });
  }

  pay() {
    if (this.cartService.getCartQuantity() > 0) {
      // TODO: Abonos
      this.ticketsEventService
        .checkCartBonds()
        .subscribe({
          next: (checkBonds) => {
            if (checkBonds.success) {
              this.dialog.open(DialogPayComponent, {
                width: '500px',
                disableClose: false,
              });
            } else {
              this.errorBondsDialog(checkBonds.errors.bonds);
            }
          }, error: (err) => {
            this.errorBondsDialog(err.error.errors.bonds);
          }
        });
    }
  }
  errorBondsDialog(bonds: any) {
    const dialogPopup = new DialogInitializer(DialogErrorBondsComponent);
    // Any data can be sent to AnyAngularComponent.
    dialogPopup.setCustomData({ bonds: bonds });

    // Set some configuration.
    dialogPopup.setConfig({
      width: '500px',
      layoutType: DialogLayoutDisplay.NONE, // SUCCESS | INFO | NONE | DANGER | WARNING
      animationIn: AppearanceAnimation.NONE,
      animationOut: DisappearanceAnimation.NONE,
      escapeKeyClose: true,
    });

    // Set some custom buttons as list.
    // SUCCESS | INFO | NONE | DANGER | WARNING | PRIMARY | SECONDARY | LINK | DARK | LIGHT
    dialogPopup.setButtons([
      new ButtonMaker('Aceptar', 'submit', ButtonLayoutDisplay.SUCCESS),
    ]);

    // Simply open the popup and observe which button is clicked and,
    // receive optional payload from AnyAngularComponent.
    dialogPopup.openDialog$().subscribe((resp) => { });
  }


  cleanCart() {
    const dialogPopup = new DialogInitializer(DialogCleanCartComponent);

    // Set some configuration.
    dialogPopup.setConfig({
      width: '500px',
      layoutType: DialogLayoutDisplay.NONE, // SUCCESS | INFO | NONE | DANGER | WARNING
      animationIn: AppearanceAnimation.NONE,
      animationOut: DisappearanceAnimation.NONE,
      escapeKeyClose: true,
    });

    // Set some custom buttons as list.
    // SUCCESS | INFO | NONE | DANGER | WARNING | PRIMARY | SECONDARY | LINK | DARK | LIGHT
    dialogPopup.setButtons([
      new ButtonMaker('Cancelar', 'cancel', ButtonLayoutDisplay.SECONDARY),
      new ButtonMaker('Aceptar', 'submit', ButtonLayoutDisplay.SUCCESS),
    ]);
    dialogPopup.openDialog$().subscribe((resp) => { });
  }

  formatNumber(floatValue = 1, decimals = 2, multiplier = 1) {
    let floatMultiplied = floatValue * multiplier;
    let stringFloat = floatMultiplied + '';
    let arraySplitFloat = stringFloat.split('.');
    let decimalsValue = '0';
    if (arraySplitFloat.length > 1) {
      decimalsValue = arraySplitFloat[1].slice(0, decimals);
    }
    let integerValue = arraySplitFloat[0];
    let arrayFullStringValue = [integerValue, decimalsValue];
    let FullStringValue = arrayFullStringValue.join('.');
    let floatFullValue = parseFloat(FullStringValue) + '';
    let formatFloatFullValue = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: decimals,
      style: 'currency',
      currency: 'EUR',
    }).format(Number(floatFullValue));
    return formatFloatFullValue;
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
  }

}
